import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_content_asset = _resolveComponent("template-content-asset")!
  const _component_template_content_content = _resolveComponent("template-content-content")!
  const _component_template_content_image = _resolveComponent("template-content-image")!
  const _component_template_content_svg = _resolveComponent("template-content-svg")!
  const _component_template_content_video = _resolveComponent("template-content-video")!
  const _component_template_content_bespoke = _resolveComponent("template-content-bespoke")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-template-area hd-col", _ctx.datum.class]),
    style: _normalizeStyle(_ctx.areaStyle)
  }, [
    (_ctx.datum.value === 'asset')
      ? (_openBlock(), _createBlock(_component_template_content_asset, {
          key: 0,
          datum: _ctx.datum,
          "carousel-index": _ctx.carouselIndex
        }, null, 8, ["datum", "carousel-index"]))
      : _createCommentVNode("", true),
    (_ctx.datum.value === 'content')
      ? (_openBlock(), _createBlock(_component_template_content_content, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.datum.value === 'image')
      ? (_openBlock(), _createBlock(_component_template_content_image, {
          key: 2,
          datum: _ctx.datum,
          "carousel-index": _ctx.carouselIndex
        }, null, 8, ["datum", "carousel-index"]))
      : _createCommentVNode("", true),
    (_ctx.datum.value === 'svg')
      ? (_openBlock(), _createBlock(_component_template_content_svg, {
          key: 3,
          datum: _ctx.datum,
          "carousel-index": _ctx.carouselIndex
        }, null, 8, ["datum", "carousel-index"]))
      : _createCommentVNode("", true),
    (_ctx.datum.value === 'video')
      ? (_openBlock(), _createBlock(_component_template_content_video, {
          key: 4,
          datum: _ctx.datum,
          "carousel-index": _ctx.carouselIndex
        }, null, 8, ["datum", "carousel-index"]))
      : _createCommentVNode("", true),
    (_ctx.datum.value === 'bespoke')
      ? (_openBlock(), _createBlock(_component_template_content_bespoke, {
          key: 5,
          datum: _ctx.datum,
          "carousel-index": _ctx.carouselIndex
        }, null, 8, ["datum", "carousel-index"]))
      : _createCommentVNode("", true)
  ], 6))
}